module.exports = __webpack_public_path__ + "95d0e670f40cb72a462cb2c8c3992c33.png";